import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import CRUDPage from '../../components/admin/CRUDPage';
import { Grid } from 'lucide-react';

export default function CardTypesPage() {
  const fields = [
    { 
      key: 'name', 
      label: 'Card Type Name', 
      type: 'text', 
      required: true,
      placeholder: 'Enter card type name',
      showInForm: true
    },
    { 
      key: 'description', 
      label: 'Description', 
      type: 'textarea', 
      required: false,
      placeholder: 'Enter card type description (optional)',
      showInForm: true
    },
  ];

  return (
    <AdminLayout>
      <div className="p-8">
        <CRUDPage
          title="Card Types"
          apiEndpoint="card-types"
          dataKey="card_types"
          fields={fields}
          icon={Grid}
        />
      </div>
    </AdminLayout>
  );
}
